export default "__VITE_ASSET__Bem33uSQ__"